/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: cEQHMEdyXB7i

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import SectionHeader from "../../SectionHeader"; // plasmic-import: BZA1gY3bmqLJ/component
import HomeSolutionsSectionCard from "../../HomeSolutionsSectionCard"; // plasmic-import: mUru5t19QSwF/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHomeSolutionsSection.module.css"; // plasmic-import: cEQHMEdyXB7i/css

import Icon52Icon from "./icons/PlasmicIcon__Icon52"; // plasmic-import: u1dWf5rSSjQ1/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon
import Icon53Icon from "./icons/PlasmicIcon__Icon53"; // plasmic-import: 8BkYGA-rJID6/icon
import IconLarge32NurseIcon from "./icons/PlasmicIcon__IconLarge32Nurse"; // plasmic-import: V0nWYr9u3aoK/icon

createPlasmicElementProxy;

export type PlasmicHomeSolutionsSection__VariantMembers = {};
export type PlasmicHomeSolutionsSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomeSolutionsSection__VariantsArgs;
export const PlasmicHomeSolutionsSection__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHomeSolutionsSection__ArgsType = {};
type ArgPropType = keyof PlasmicHomeSolutionsSection__ArgsType;
export const PlasmicHomeSolutionsSection__ArgProps = new Array<ArgPropType>();

export type PlasmicHomeSolutionsSection__OverridesType = {
  solutions?: Flex__<"section">;
  desktop?: Flex__<"div">;
  wrapper?: Flex__<"div">;
  row?: Flex__<"div">;
  col?: Flex__<"div">;
  cards?: Flex__<"div">;
  graduateCard?: Flex__<typeof HomeSolutionsSectionCard>;
  cardHeader4?: Flex__<"div">;
  title?: Flex__<"h4">;
  icon?: Flex__<"svg">;
  content4?: Flex__<"div">;
  text4?: Flex__<"p">;
  physicianCard?: Flex__<typeof HomeSolutionsSectionCard>;
  cardHeader?: Flex__<"div">;
  title2?: Flex__<"h4">;
  icon2?: Flex__<"svg">;
  content?: Flex__<"div">;
  text?: Flex__<"p">;
  nursingCard?: Flex__<typeof HomeSolutionsSectionCard>;
  cardHeader2?: Flex__<"div">;
  title3?: Flex__<"h4">;
  icon3?: Flex__<"svg">;
  content2?: Flex__<"div">;
  text2?: Flex__<"p">;
  bgImage?: Flex__<typeof PlasmicImg__>;
  tablet?: Flex__<"div">;
  wrapper2?: Flex__<"div">;
  row2?: Flex__<"div">;
  col2?: Flex__<"div">;
  cards3?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  graduateCard3?: Flex__<typeof HomeSolutionsSectionCard>;
  cardHeader7?: Flex__<"div">;
  title7?: Flex__<"h4">;
  icon7?: Flex__<"svg">;
  content7?: Flex__<"div">;
  text7?: Flex__<"p">;
  physicianCard3?: Flex__<typeof HomeSolutionsSectionCard>;
  cardHeader8?: Flex__<"div">;
  title8?: Flex__<"h4">;
  icon8?: Flex__<"svg">;
  content8?: Flex__<"div">;
  text8?: Flex__<"p">;
  nursingCard3?: Flex__<typeof HomeSolutionsSectionCard>;
  cardHeader9?: Flex__<"div">;
  title9?: Flex__<"h4">;
  icon9?: Flex__<"svg">;
  content9?: Flex__<"div">;
  text9?: Flex__<"p">;
  bgImage2?: Flex__<typeof PlasmicImg__>;
  mobile?: Flex__<"div">;
  cards2?: Flex__<"div">;
  graduateCard2?: Flex__<typeof HomeSolutionsSectionCard>;
  cardHeader5?: Flex__<"div">;
  title4?: Flex__<"h4">;
  icon4?: Flex__<"svg">;
  content5?: Flex__<"div">;
  text5?: Flex__<"p">;
  physicianCard2?: Flex__<typeof HomeSolutionsSectionCard>;
  cardHeader3?: Flex__<"div">;
  title5?: Flex__<"h4">;
  icon5?: Flex__<"svg">;
  content3?: Flex__<"div">;
  text3?: Flex__<"p">;
  nursingCard2?: Flex__<typeof HomeSolutionsSectionCard>;
  cardHeader6?: Flex__<"div">;
  title6?: Flex__<"h4">;
  icon6?: Flex__<"svg">;
  content6?: Flex__<"div">;
  text6?: Flex__<"p">;
};

export interface DefaultHomeSolutionsSectionProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeSolutionsSection__RenderFunc(props: {
  variants: PlasmicHomeSolutionsSection__VariantsArgs;
  args: PlasmicHomeSolutionsSection__ArgsType;
  overrides: PlasmicHomeSolutionsSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"solutions"}
      data-plasmic-override={overrides.solutions}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.solutions
      )}
    >
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? true
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? false
            : true
      ) ? (
        <div
          data-plasmic-name={"desktop"}
          data-plasmic-override={overrides.desktop}
          className={classNames("all", sty.desktop)}
        >
          <div
            data-plasmic-name={"wrapper"}
            data-plasmic-override={overrides.wrapper}
            className={classNames("all", sty.wrapper)}
          >
            <div
              data-plasmic-name={"row"}
              data-plasmic-override={overrides.row}
              className={classNames("all", sty.row)}
            >
              <div
                data-plasmic-name={"col"}
                data-plasmic-override={overrides.col}
                className={classNames("all", sty.col)}
              >
                <SectionHeader
                  className={classNames(
                    "__wab_instance",
                    sty.sectionHeader__mevV7
                  )}
                  description={
                    "Every medical education program is unique. MyEvaluations delivers flexible solutions designed to meet the educational, accreditation, and operational needs\u00a0of Graduate Medical Education, Physician Assistant, and Nursing programs.\n\nAcross all specialties or disciplines, every institution benefits from Better Assessments, Better Insight, and Better Decisions that support Continuous Educational Improvement."
                  }
                  showDescription={true}
                  showSubtitle={true}
                  subtitle={"Tailored Solutions"}
                  title={"Supporting Every Medical Education Environment"}
                />
              </div>
            </div>
            <div
              data-plasmic-name={"cards"}
              data-plasmic-override={overrides.cards}
              className={classNames("all", sty.cards)}
            >
              <HomeSolutionsSectionCard
                data-plasmic-name={"graduateCard"}
                data-plasmic-override={overrides.graduateCard}
                className={classNames("__wab_instance", sty.graduateCard)}
              >
                <div
                  data-plasmic-name={"cardHeader4"}
                  data-plasmic-override={overrides.cardHeader4}
                  className={classNames("all", sty.cardHeader4)}
                >
                  <h4
                    data-plasmic-name={"title"}
                    data-plasmic-override={overrides.title}
                    className={classNames(
                      "all",
                      "h4",
                      "h4__bvRZj",
                      "__wab_text",
                      sty.title
                    )}
                  >
                    {"Graduate\nMedical Education"}
                  </h4>
                  <Icon52Icon
                    data-plasmic-name={"icon"}
                    data-plasmic-override={overrides.icon}
                    className={classNames("all", sty.icon)}
                    role={"img"}
                  />
                </div>
                <div
                  data-plasmic-name={"content4"}
                  data-plasmic-override={overrides.content4}
                  className={classNames("all", sty.content4)}
                >
                  <p
                    data-plasmic-name={"text4"}
                    data-plasmic-override={overrides.text4}
                    className={classNames(
                      "all",
                      "p",
                      "p__bvRZj",
                      "__wab_text",
                      sty.text4
                    )}
                  >
                    {
                      "Support residency and fellowship programs with comprehensive tools for assessments, milestones, EPAs, Clinical Competency Committees, Annual Program Evaluation, Annual Institutional Review, scheduling, clinical hours, onboarding, and institutional reporting. MyEvaluations helps programs strengthen educational quality while simplifying accreditation and administrative processes."
                    }
                  </p>
                  {false ? (
                    <Button
                      className={classNames(
                        "__wab_instance",
                        sty.button__sl1Db
                      )}
                      color={"sky"}
                      size={"medium"}
                    >
                      {"LEARN MORE"}
                    </Button>
                  ) : null}
                </div>
              </HomeSolutionsSectionCard>
              <HomeSolutionsSectionCard
                data-plasmic-name={"physicianCard"}
                data-plasmic-override={overrides.physicianCard}
                className={classNames("__wab_instance", sty.physicianCard)}
              >
                <div
                  data-plasmic-name={"cardHeader"}
                  data-plasmic-override={overrides.cardHeader}
                  className={classNames("all", sty.cardHeader)}
                >
                  <h4
                    data-plasmic-name={"title2"}
                    data-plasmic-override={overrides.title2}
                    className={classNames(
                      "all",
                      "h4",
                      "h4__bvRZj",
                      "__wab_text",
                      sty.title2
                    )}
                  >
                    {"Physician \nAssistant Programs"}
                  </h4>
                  <Icon53Icon
                    data-plasmic-name={"icon2"}
                    data-plasmic-override={overrides.icon2}
                    className={classNames("all", sty.icon2)}
                    role={"img"}
                  />
                </div>
                <div
                  data-plasmic-name={"content"}
                  data-plasmic-override={overrides.content}
                  className={classNames("all", sty.content)}
                >
                  <p
                    data-plasmic-name={"text"}
                    data-plasmic-override={overrides.text}
                    className={classNames(
                      "all",
                      "p",
                      "p__bvRZj",
                      "__wab_text",
                      sty.text
                    )}
                  >
                    {
                      "Enhance competency-based education through meaningful assessments, timely learner feedback, curriculum management, clinical tracking, and performance analytics. Identify opportunities for learner growth earlier while supporting faculty with efficient educational workflows.\n\n\n\n"
                    }
                  </p>
                  {false ? (
                    <Button
                      className={classNames(
                        "__wab_instance",
                        sty.button___9Lpr
                      )}
                      color={"sky"}
                      size={"medium"}
                    >
                      {"LEARN MORE"}
                    </Button>
                  ) : null}
                </div>
              </HomeSolutionsSectionCard>
              <HomeSolutionsSectionCard
                data-plasmic-name={"nursingCard"}
                data-plasmic-override={overrides.nursingCard}
                className={classNames("__wab_instance", sty.nursingCard)}
              >
                <div
                  data-plasmic-name={"cardHeader2"}
                  data-plasmic-override={overrides.cardHeader2}
                  className={classNames("all", sty.cardHeader2)}
                >
                  <h4
                    data-plasmic-name={"title3"}
                    data-plasmic-override={overrides.title3}
                    className={classNames(
                      "all",
                      "h4",
                      "h4__bvRZj",
                      "__wab_text",
                      sty.title3
                    )}
                  >
                    {"Nursing Programs"}
                  </h4>
                  <IconLarge32NurseIcon
                    data-plasmic-name={"icon3"}
                    data-plasmic-override={overrides.icon3}
                    className={classNames("all", sty.icon3)}
                    role={"img"}
                  />
                </div>
                <div
                  data-plasmic-name={"content2"}
                  data-plasmic-override={overrides.content2}
                  className={classNames("all", sty.content2)}
                >
                  <p
                    data-plasmic-name={"text2"}
                    data-plasmic-override={overrides.text2}
                    className={classNames(
                      "all",
                      "p",
                      "p__bvRZj",
                      "__wab_text",
                      sty.text2
                    )}
                  >
                    {
                      "Strengthen clinical education with competency assessments, return demonstrations, clinical learning contracts, skills tracking, and comprehensive learner evaluations. MyEvaluations provides the educational insight needed to support student success and continuous program improvement.\n\n\n"
                    }
                  </p>
                  {false ? (
                    <Button
                      className={classNames(
                        "__wab_instance",
                        sty.button__o2Knj
                      )}
                      color={"sky"}
                      size={"medium"}
                    >
                      {"LEARN MORE"}
                    </Button>
                  ) : null}
                </div>
              </HomeSolutionsSectionCard>
            </div>
          </div>
          <PlasmicImg__
            data-plasmic-name={"bgImage"}
            data-plasmic-override={overrides.bgImage}
            alt={"Smiling nurse working on a laptop"}
            className={classNames(sty.bgImage)}
            displayHeight={"815px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"850px"}
            loader={"plasmic"}
            loading={"eager"}
            src={{
              src: "https://img.plasmic.app/img-optimizer/v1/img/a859255eee606a8b08071c6b5b29fee4.png",
              fullWidth: 912,
              fullHeight: 754
            }}
          />
        </div>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? true
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? true
            : false
      ) ? (
        <div
          data-plasmic-name={"tablet"}
          data-plasmic-override={overrides.tablet}
          className={classNames("all", sty.tablet)}
        >
          <div
            data-plasmic-name={"wrapper2"}
            data-plasmic-override={overrides.wrapper2}
            className={classNames("all", sty.wrapper2)}
          >
            <div
              data-plasmic-name={"row2"}
              data-plasmic-override={overrides.row2}
              className={classNames("all", sty.row2)}
            >
              <div
                data-plasmic-name={"col2"}
                data-plasmic-override={overrides.col2}
                className={classNames("all", sty.col2)}
              >
                <SectionHeader
                  className={classNames(
                    "__wab_instance",
                    sty.sectionHeader__yIvH6
                  )}
                  description={
                    "Every medical education program is unique. MyEvaluations delivers flexible solutions designed to meet the educational, accreditation, and operational needs\u00a0of Graduate Medical Education, Physician Assistant, and Nursing programs.\nAcross all specialties or disciplines, every institution benefits from Better Assessments, Better Insight, and Better Decisions that support Continuous Educational Improvement."
                  }
                  showDescription={true}
                  showSubtitle={true}
                  subtitle={"Tailored Solutions"}
                  title={"Supporting Every Medical Education Environment"}
                />
              </div>
            </div>
            <div
              data-plasmic-name={"cards3"}
              data-plasmic-override={overrides.cards3}
              className={classNames("all", sty.cards3)}
            >
              <div
                data-plasmic-name={"freeBox"}
                data-plasmic-override={overrides.freeBox}
                className={classNames("all", sty.freeBox)}
              >
                <HomeSolutionsSectionCard
                  data-plasmic-name={"graduateCard3"}
                  data-plasmic-override={overrides.graduateCard3}
                  className={classNames("__wab_instance", sty.graduateCard3)}
                >
                  <div
                    data-plasmic-name={"cardHeader7"}
                    data-plasmic-override={overrides.cardHeader7}
                    className={classNames("all", sty.cardHeader7)}
                  >
                    <h4
                      data-plasmic-name={"title7"}
                      data-plasmic-override={overrides.title7}
                      className={classNames(
                        "all",
                        "h4",
                        "h4__bvRZj",
                        "__wab_text",
                        sty.title7
                      )}
                    >
                      {"Graduate Medical Education Programs"}
                    </h4>
                    <Icon52Icon
                      data-plasmic-name={"icon7"}
                      data-plasmic-override={overrides.icon7}
                      className={classNames("all", sty.icon7)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content7"}
                    data-plasmic-override={overrides.content7}
                    className={classNames("all", sty.content7)}
                  >
                    <p
                      data-plasmic-name={"text7"}
                      data-plasmic-override={overrides.text7}
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.text7
                      )}
                    >
                      {
                        "Support residency and fellowship programs with comprehensive tools for assessments, milestones, EPAs, Clinical Competency Committees, Annual Program Evaluation, Annual Institutional Review, scheduling, clinical hours, onboarding, and institutional reporting. MyEvaluations helps programs strengthen educational quality while simplifying accreditation and administrative processes."
                      }
                    </p>
                    {false ? (
                      <Button
                        className={classNames(
                          "__wab_instance",
                          sty.button__wIMtU
                        )}
                        color={"sky"}
                        size={"medium"}
                      >
                        {"LEARN MORE"}
                      </Button>
                    ) : null}
                  </div>
                </HomeSolutionsSectionCard>
                <HomeSolutionsSectionCard
                  data-plasmic-name={"physicianCard3"}
                  data-plasmic-override={overrides.physicianCard3}
                  className={classNames("__wab_instance", sty.physicianCard3)}
                >
                  <div
                    data-plasmic-name={"cardHeader8"}
                    data-plasmic-override={overrides.cardHeader8}
                    className={classNames("all", sty.cardHeader8)}
                  >
                    <h4
                      data-plasmic-name={"title8"}
                      data-plasmic-override={overrides.title8}
                      className={classNames(
                        "all",
                        "h4",
                        "h4__bvRZj",
                        "__wab_text",
                        sty.title8
                      )}
                    >
                      {"Physician Assistant Programs"}
                    </h4>
                    <Icon53Icon
                      data-plasmic-name={"icon8"}
                      data-plasmic-override={overrides.icon8}
                      className={classNames("all", sty.icon8)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content8"}
                    data-plasmic-override={overrides.content8}
                    className={classNames("all", sty.content8)}
                  >
                    <p
                      data-plasmic-name={"text8"}
                      data-plasmic-override={overrides.text8}
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.text8
                      )}
                    >
                      {
                        "Enhance competency-based education through meaningful assessments, timely learner feedback, curriculum management, clinical tracking, and performance analytics. Identify opportunities for learner growth earlier while supporting faculty with efficient educational workflows."
                      }
                    </p>
                    {false ? (
                      <Button
                        className={classNames(
                          "__wab_instance",
                          sty.button__kW4Ki
                        )}
                        color={"sky"}
                        size={"medium"}
                      >
                        {"LEARN MORE"}
                      </Button>
                    ) : null}
                  </div>
                </HomeSolutionsSectionCard>
              </div>
              <HomeSolutionsSectionCard
                data-plasmic-name={"nursingCard3"}
                data-plasmic-override={overrides.nursingCard3}
                className={classNames("__wab_instance", sty.nursingCard3)}
              >
                <div
                  data-plasmic-name={"cardHeader9"}
                  data-plasmic-override={overrides.cardHeader9}
                  className={classNames("all", sty.cardHeader9)}
                >
                  <h4
                    data-plasmic-name={"title9"}
                    data-plasmic-override={overrides.title9}
                    className={classNames(
                      "all",
                      "h4",
                      "h4__bvRZj",
                      "__wab_text",
                      sty.title9
                    )}
                  >
                    {"Nursing Programs"}
                  </h4>
                  <IconLarge32NurseIcon
                    data-plasmic-name={"icon9"}
                    data-plasmic-override={overrides.icon9}
                    className={classNames("all", sty.icon9)}
                    role={"img"}
                  />
                </div>
                <div
                  data-plasmic-name={"content9"}
                  data-plasmic-override={overrides.content9}
                  className={classNames("all", sty.content9)}
                >
                  <p
                    data-plasmic-name={"text9"}
                    data-plasmic-override={overrides.text9}
                    className={classNames(
                      "all",
                      "p",
                      "p__bvRZj",
                      "__wab_text",
                      sty.text9
                    )}
                  >
                    {
                      "Strengthen clinical education with competency assessments, return demonstrations, clinical learning contracts, skills tracking, and comprehensive learner evaluations. MyEvaluations provides the educational insight needed to support student success and continuous program improvement."
                    }
                  </p>
                  {false ? (
                    <Button
                      className={classNames(
                        "__wab_instance",
                        sty.button___5Ctym
                      )}
                      color={"sky"}
                      size={"medium"}
                    >
                      {"LEARN MORE"}
                    </Button>
                  ) : null}
                </div>
              </HomeSolutionsSectionCard>
            </div>
          </div>
          <PlasmicImg__
            data-plasmic-name={"bgImage2"}
            data-plasmic-override={overrides.bgImage2}
            alt={""}
            className={classNames(sty.bgImage2)}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"55%"}
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://site-assets.plasmic.app/7f47badaf65154fa1135866dbeda3bf5.svg",
              fullWidth: 153,
              fullHeight: 150,
              aspectRatio: 1.019894
            }}
          />
        </div>
      ) : null}
      <div
        data-plasmic-name={"mobile"}
        data-plasmic-override={overrides.mobile}
        className={classNames("all", sty.mobile)}
      >
        <SectionHeader
          className={classNames("__wab_instance", sty.sectionHeader__oaNpk)}
          description={
            "Every medical education program is unique. MyEvaluations delivers flexible solutions designed to meet the educational, accreditation, and operational needs\u00a0of Graduate Medical Education, Physician Assistant, and Nursing programs.\nAcross all specialties or disciplines, every institution benefits from Better Assessments, Better Insight, and Better Decisions that support Continuous Educational Improvement."
          }
          showDescription={true}
          showSubtitle={true}
          subtitle={"Tailored Solutions"}
          title={"Supporting Every Medical Education Environment"}
        />

        <div
          data-plasmic-name={"cards2"}
          data-plasmic-override={overrides.cards2}
          className={classNames("all", sty.cards2)}
        >
          <HomeSolutionsSectionCard
            data-plasmic-name={"graduateCard2"}
            data-plasmic-override={overrides.graduateCard2}
            className={classNames("__wab_instance", sty.graduateCard2)}
          >
            <div
              data-plasmic-name={"cardHeader5"}
              data-plasmic-override={overrides.cardHeader5}
              className={classNames("all", sty.cardHeader5)}
            >
              <h4
                data-plasmic-name={"title4"}
                data-plasmic-override={overrides.title4}
                className={classNames(
                  "all",
                  "h4",
                  "h4__bvRZj",
                  "__wab_text",
                  sty.title4
                )}
              >
                {"Graduate Medical Education Programs"}
              </h4>
              <Icon52Icon
                data-plasmic-name={"icon4"}
                data-plasmic-override={overrides.icon4}
                className={classNames("all", sty.icon4)}
                role={"img"}
              />
            </div>
            <div
              data-plasmic-name={"content5"}
              data-plasmic-override={overrides.content5}
              className={classNames("all", sty.content5)}
            >
              <p
                data-plasmic-name={"text5"}
                data-plasmic-override={overrides.text5}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text5
                )}
              >
                {hasVariant(globalVariants, "mobile", "mobileXSmall")
                  ? "Support residency and fellowship programs with comprehensive tools for assessments, milestones, EPAs, Clinical Competency Committees, Annual Program Evaluation, Annual Institutional Review, scheduling, clinical hours, onboarding, and institutional reporting. MyEvaluations helps programs strengthen educational quality while simplifying accreditation and administrative processes."
                  : "Support residency and fellowship programs with comprehensive tools for assessments, milestones, EPAs, Clinical Competency Committees, Annual Program Evaluation, Annual Institutional Review, scheduling, clinical hours, onboarding, and institutional reporting. MyEvaluations helps programs strengthen educational quality while simplifying accreditation and administrative processes."}
              </p>
              {(
                hasVariant(globalVariants, "mobile", "mobile") ? false : true
              ) ? (
                <Button
                  className={classNames("__wab_instance", sty.button___0VyIw)}
                  color={"sky"}
                  size={"medium"}
                >
                  {"LEARN MORE"}
                </Button>
              ) : null}
            </div>
          </HomeSolutionsSectionCard>
          <HomeSolutionsSectionCard
            data-plasmic-name={"physicianCard2"}
            data-plasmic-override={overrides.physicianCard2}
            className={classNames("__wab_instance", sty.physicianCard2)}
          >
            <div
              data-plasmic-name={"cardHeader3"}
              data-plasmic-override={overrides.cardHeader3}
              className={classNames("all", sty.cardHeader3)}
            >
              <h4
                data-plasmic-name={"title5"}
                data-plasmic-override={overrides.title5}
                className={classNames(
                  "all",
                  "h4",
                  "h4__bvRZj",
                  "__wab_text",
                  sty.title5
                )}
              >
                {"Physician Assistant Programs"}
              </h4>
              <Icon53Icon
                data-plasmic-name={"icon5"}
                data-plasmic-override={overrides.icon5}
                className={classNames("all", sty.icon5)}
                role={"img"}
              />
            </div>
            <div
              data-plasmic-name={"content3"}
              data-plasmic-override={overrides.content3}
              className={classNames("all", sty.content3)}
            >
              <p
                data-plasmic-name={"text3"}
                data-plasmic-override={overrides.text3}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text3
                )}
              >
                {hasVariant(globalVariants, "mobile", "mobileXSmall")
                  ? "Enhance competency-based education through meaningful assessments, timely learner feedback, curriculum management, clinical tracking, and performance analytics. Identify opportunities for learner growth earlier while supporting faculty with efficient educational workflows."
                  : "Enhance competency-based education through meaningful assessments, timely learner feedback, curriculum management, clinical tracking, and performance analytics. Identify opportunities for learner growth earlier while supporting faculty with efficient educational workflows."}
              </p>
              {(
                hasVariant(globalVariants, "mobile", "mobile") ? false : true
              ) ? (
                <Button
                  className={classNames("__wab_instance", sty.button__rrZyv)}
                  color={"sky"}
                  size={"medium"}
                >
                  {"LEARN MORE"}
                </Button>
              ) : null}
            </div>
          </HomeSolutionsSectionCard>
          <HomeSolutionsSectionCard
            data-plasmic-name={"nursingCard2"}
            data-plasmic-override={overrides.nursingCard2}
            className={classNames("__wab_instance", sty.nursingCard2)}
          >
            <div
              data-plasmic-name={"cardHeader6"}
              data-plasmic-override={overrides.cardHeader6}
              className={classNames("all", sty.cardHeader6)}
            >
              <h4
                data-plasmic-name={"title6"}
                data-plasmic-override={overrides.title6}
                className={classNames(
                  "all",
                  "h4",
                  "h4__bvRZj",
                  "__wab_text",
                  sty.title6
                )}
              >
                {"Nursing Programs"}
              </h4>
              <IconLarge32NurseIcon
                data-plasmic-name={"icon6"}
                data-plasmic-override={overrides.icon6}
                className={classNames("all", sty.icon6)}
                role={"img"}
              />
            </div>
            <div
              data-plasmic-name={"content6"}
              data-plasmic-override={overrides.content6}
              className={classNames("all", sty.content6)}
            >
              <p
                data-plasmic-name={"text6"}
                data-plasmic-override={overrides.text6}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text6
                )}
              >
                {
                  "Strengthen clinical education with competency assessments, return demonstrations, clinical learning contracts, skills tracking, and comprehensive learner evaluations. MyEvaluations provides the educational insight needed to support student success and continuous program improvement."
                }
              </p>
              {(
                hasVariant(globalVariants, "mobile", "mobile") ? false : true
              ) ? (
                <Button
                  className={classNames("__wab_instance", sty.button__ws1Ys)}
                  color={"sky"}
                  size={"medium"}
                >
                  {"LEARN MORE"}
                </Button>
              ) : null}
            </div>
          </HomeSolutionsSectionCard>
        </div>
      </div>
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  solutions: [
    "solutions",
    "desktop",
    "wrapper",
    "row",
    "col",
    "cards",
    "graduateCard",
    "cardHeader4",
    "title",
    "icon",
    "content4",
    "text4",
    "physicianCard",
    "cardHeader",
    "title2",
    "icon2",
    "content",
    "text",
    "nursingCard",
    "cardHeader2",
    "title3",
    "icon3",
    "content2",
    "text2",
    "bgImage",
    "tablet",
    "wrapper2",
    "row2",
    "col2",
    "cards3",
    "freeBox",
    "graduateCard3",
    "cardHeader7",
    "title7",
    "icon7",
    "content7",
    "text7",
    "physicianCard3",
    "cardHeader8",
    "title8",
    "icon8",
    "content8",
    "text8",
    "nursingCard3",
    "cardHeader9",
    "title9",
    "icon9",
    "content9",
    "text9",
    "bgImage2",
    "mobile",
    "cards2",
    "graduateCard2",
    "cardHeader5",
    "title4",
    "icon4",
    "content5",
    "text5",
    "physicianCard2",
    "cardHeader3",
    "title5",
    "icon5",
    "content3",
    "text3",
    "nursingCard2",
    "cardHeader6",
    "title6",
    "icon6",
    "content6",
    "text6"
  ],
  desktop: [
    "desktop",
    "wrapper",
    "row",
    "col",
    "cards",
    "graduateCard",
    "cardHeader4",
    "title",
    "icon",
    "content4",
    "text4",
    "physicianCard",
    "cardHeader",
    "title2",
    "icon2",
    "content",
    "text",
    "nursingCard",
    "cardHeader2",
    "title3",
    "icon3",
    "content2",
    "text2",
    "bgImage"
  ],
  wrapper: [
    "wrapper",
    "row",
    "col",
    "cards",
    "graduateCard",
    "cardHeader4",
    "title",
    "icon",
    "content4",
    "text4",
    "physicianCard",
    "cardHeader",
    "title2",
    "icon2",
    "content",
    "text",
    "nursingCard",
    "cardHeader2",
    "title3",
    "icon3",
    "content2",
    "text2"
  ],
  row: ["row", "col"],
  col: ["col"],
  cards: [
    "cards",
    "graduateCard",
    "cardHeader4",
    "title",
    "icon",
    "content4",
    "text4",
    "physicianCard",
    "cardHeader",
    "title2",
    "icon2",
    "content",
    "text",
    "nursingCard",
    "cardHeader2",
    "title3",
    "icon3",
    "content2",
    "text2"
  ],
  graduateCard: [
    "graduateCard",
    "cardHeader4",
    "title",
    "icon",
    "content4",
    "text4"
  ],
  cardHeader4: ["cardHeader4", "title", "icon"],
  title: ["title"],
  icon: ["icon"],
  content4: ["content4", "text4"],
  text4: ["text4"],
  physicianCard: [
    "physicianCard",
    "cardHeader",
    "title2",
    "icon2",
    "content",
    "text"
  ],
  cardHeader: ["cardHeader", "title2", "icon2"],
  title2: ["title2"],
  icon2: ["icon2"],
  content: ["content", "text"],
  text: ["text"],
  nursingCard: [
    "nursingCard",
    "cardHeader2",
    "title3",
    "icon3",
    "content2",
    "text2"
  ],
  cardHeader2: ["cardHeader2", "title3", "icon3"],
  title3: ["title3"],
  icon3: ["icon3"],
  content2: ["content2", "text2"],
  text2: ["text2"],
  bgImage: ["bgImage"],
  tablet: [
    "tablet",
    "wrapper2",
    "row2",
    "col2",
    "cards3",
    "freeBox",
    "graduateCard3",
    "cardHeader7",
    "title7",
    "icon7",
    "content7",
    "text7",
    "physicianCard3",
    "cardHeader8",
    "title8",
    "icon8",
    "content8",
    "text8",
    "nursingCard3",
    "cardHeader9",
    "title9",
    "icon9",
    "content9",
    "text9",
    "bgImage2"
  ],
  wrapper2: [
    "wrapper2",
    "row2",
    "col2",
    "cards3",
    "freeBox",
    "graduateCard3",
    "cardHeader7",
    "title7",
    "icon7",
    "content7",
    "text7",
    "physicianCard3",
    "cardHeader8",
    "title8",
    "icon8",
    "content8",
    "text8",
    "nursingCard3",
    "cardHeader9",
    "title9",
    "icon9",
    "content9",
    "text9"
  ],
  row2: ["row2", "col2"],
  col2: ["col2"],
  cards3: [
    "cards3",
    "freeBox",
    "graduateCard3",
    "cardHeader7",
    "title7",
    "icon7",
    "content7",
    "text7",
    "physicianCard3",
    "cardHeader8",
    "title8",
    "icon8",
    "content8",
    "text8",
    "nursingCard3",
    "cardHeader9",
    "title9",
    "icon9",
    "content9",
    "text9"
  ],
  freeBox: [
    "freeBox",
    "graduateCard3",
    "cardHeader7",
    "title7",
    "icon7",
    "content7",
    "text7",
    "physicianCard3",
    "cardHeader8",
    "title8",
    "icon8",
    "content8",
    "text8"
  ],
  graduateCard3: [
    "graduateCard3",
    "cardHeader7",
    "title7",
    "icon7",
    "content7",
    "text7"
  ],
  cardHeader7: ["cardHeader7", "title7", "icon7"],
  title7: ["title7"],
  icon7: ["icon7"],
  content7: ["content7", "text7"],
  text7: ["text7"],
  physicianCard3: [
    "physicianCard3",
    "cardHeader8",
    "title8",
    "icon8",
    "content8",
    "text8"
  ],
  cardHeader8: ["cardHeader8", "title8", "icon8"],
  title8: ["title8"],
  icon8: ["icon8"],
  content8: ["content8", "text8"],
  text8: ["text8"],
  nursingCard3: [
    "nursingCard3",
    "cardHeader9",
    "title9",
    "icon9",
    "content9",
    "text9"
  ],
  cardHeader9: ["cardHeader9", "title9", "icon9"],
  title9: ["title9"],
  icon9: ["icon9"],
  content9: ["content9", "text9"],
  text9: ["text9"],
  bgImage2: ["bgImage2"],
  mobile: [
    "mobile",
    "cards2",
    "graduateCard2",
    "cardHeader5",
    "title4",
    "icon4",
    "content5",
    "text5",
    "physicianCard2",
    "cardHeader3",
    "title5",
    "icon5",
    "content3",
    "text3",
    "nursingCard2",
    "cardHeader6",
    "title6",
    "icon6",
    "content6",
    "text6"
  ],
  cards2: [
    "cards2",
    "graduateCard2",
    "cardHeader5",
    "title4",
    "icon4",
    "content5",
    "text5",
    "physicianCard2",
    "cardHeader3",
    "title5",
    "icon5",
    "content3",
    "text3",
    "nursingCard2",
    "cardHeader6",
    "title6",
    "icon6",
    "content6",
    "text6"
  ],
  graduateCard2: [
    "graduateCard2",
    "cardHeader5",
    "title4",
    "icon4",
    "content5",
    "text5"
  ],
  cardHeader5: ["cardHeader5", "title4", "icon4"],
  title4: ["title4"],
  icon4: ["icon4"],
  content5: ["content5", "text5"],
  text5: ["text5"],
  physicianCard2: [
    "physicianCard2",
    "cardHeader3",
    "title5",
    "icon5",
    "content3",
    "text3"
  ],
  cardHeader3: ["cardHeader3", "title5", "icon5"],
  title5: ["title5"],
  icon5: ["icon5"],
  content3: ["content3", "text3"],
  text3: ["text3"],
  nursingCard2: [
    "nursingCard2",
    "cardHeader6",
    "title6",
    "icon6",
    "content6",
    "text6"
  ],
  cardHeader6: ["cardHeader6", "title6", "icon6"],
  title6: ["title6"],
  icon6: ["icon6"],
  content6: ["content6", "text6"],
  text6: ["text6"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  solutions: "section";
  desktop: "div";
  wrapper: "div";
  row: "div";
  col: "div";
  cards: "div";
  graduateCard: typeof HomeSolutionsSectionCard;
  cardHeader4: "div";
  title: "h4";
  icon: "svg";
  content4: "div";
  text4: "p";
  physicianCard: typeof HomeSolutionsSectionCard;
  cardHeader: "div";
  title2: "h4";
  icon2: "svg";
  content: "div";
  text: "p";
  nursingCard: typeof HomeSolutionsSectionCard;
  cardHeader2: "div";
  title3: "h4";
  icon3: "svg";
  content2: "div";
  text2: "p";
  bgImage: typeof PlasmicImg__;
  tablet: "div";
  wrapper2: "div";
  row2: "div";
  col2: "div";
  cards3: "div";
  freeBox: "div";
  graduateCard3: typeof HomeSolutionsSectionCard;
  cardHeader7: "div";
  title7: "h4";
  icon7: "svg";
  content7: "div";
  text7: "p";
  physicianCard3: typeof HomeSolutionsSectionCard;
  cardHeader8: "div";
  title8: "h4";
  icon8: "svg";
  content8: "div";
  text8: "p";
  nursingCard3: typeof HomeSolutionsSectionCard;
  cardHeader9: "div";
  title9: "h4";
  icon9: "svg";
  content9: "div";
  text9: "p";
  bgImage2: typeof PlasmicImg__;
  mobile: "div";
  cards2: "div";
  graduateCard2: typeof HomeSolutionsSectionCard;
  cardHeader5: "div";
  title4: "h4";
  icon4: "svg";
  content5: "div";
  text5: "p";
  physicianCard2: typeof HomeSolutionsSectionCard;
  cardHeader3: "div";
  title5: "h4";
  icon5: "svg";
  content3: "div";
  text3: "p";
  nursingCard2: typeof HomeSolutionsSectionCard;
  cardHeader6: "div";
  title6: "h4";
  icon6: "svg";
  content6: "div";
  text6: "p";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeSolutionsSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeSolutionsSection__VariantsArgs;
    args?: PlasmicHomeSolutionsSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomeSolutionsSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomeSolutionsSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeSolutionsSection__ArgProps,
          internalVariantPropNames: PlasmicHomeSolutionsSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeSolutionsSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "solutions") {
    func.displayName = "PlasmicHomeSolutionsSection";
  } else {
    func.displayName = `PlasmicHomeSolutionsSection.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeSolutionsSection = Object.assign(
  // Top-level PlasmicHomeSolutionsSection renders the root element
  makeNodeComponent("solutions"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    wrapper: makeNodeComponent("wrapper"),
    row: makeNodeComponent("row"),
    col: makeNodeComponent("col"),
    cards: makeNodeComponent("cards"),
    graduateCard: makeNodeComponent("graduateCard"),
    cardHeader4: makeNodeComponent("cardHeader4"),
    title: makeNodeComponent("title"),
    icon: makeNodeComponent("icon"),
    content4: makeNodeComponent("content4"),
    text4: makeNodeComponent("text4"),
    physicianCard: makeNodeComponent("physicianCard"),
    cardHeader: makeNodeComponent("cardHeader"),
    title2: makeNodeComponent("title2"),
    icon2: makeNodeComponent("icon2"),
    content: makeNodeComponent("content"),
    text: makeNodeComponent("text"),
    nursingCard: makeNodeComponent("nursingCard"),
    cardHeader2: makeNodeComponent("cardHeader2"),
    title3: makeNodeComponent("title3"),
    icon3: makeNodeComponent("icon3"),
    content2: makeNodeComponent("content2"),
    text2: makeNodeComponent("text2"),
    bgImage: makeNodeComponent("bgImage"),
    tablet: makeNodeComponent("tablet"),
    wrapper2: makeNodeComponent("wrapper2"),
    row2: makeNodeComponent("row2"),
    col2: makeNodeComponent("col2"),
    cards3: makeNodeComponent("cards3"),
    freeBox: makeNodeComponent("freeBox"),
    graduateCard3: makeNodeComponent("graduateCard3"),
    cardHeader7: makeNodeComponent("cardHeader7"),
    title7: makeNodeComponent("title7"),
    icon7: makeNodeComponent("icon7"),
    content7: makeNodeComponent("content7"),
    text7: makeNodeComponent("text7"),
    physicianCard3: makeNodeComponent("physicianCard3"),
    cardHeader8: makeNodeComponent("cardHeader8"),
    title8: makeNodeComponent("title8"),
    icon8: makeNodeComponent("icon8"),
    content8: makeNodeComponent("content8"),
    text8: makeNodeComponent("text8"),
    nursingCard3: makeNodeComponent("nursingCard3"),
    cardHeader9: makeNodeComponent("cardHeader9"),
    title9: makeNodeComponent("title9"),
    icon9: makeNodeComponent("icon9"),
    content9: makeNodeComponent("content9"),
    text9: makeNodeComponent("text9"),
    bgImage2: makeNodeComponent("bgImage2"),
    mobile: makeNodeComponent("mobile"),
    cards2: makeNodeComponent("cards2"),
    graduateCard2: makeNodeComponent("graduateCard2"),
    cardHeader5: makeNodeComponent("cardHeader5"),
    title4: makeNodeComponent("title4"),
    icon4: makeNodeComponent("icon4"),
    content5: makeNodeComponent("content5"),
    text5: makeNodeComponent("text5"),
    physicianCard2: makeNodeComponent("physicianCard2"),
    cardHeader3: makeNodeComponent("cardHeader3"),
    title5: makeNodeComponent("title5"),
    icon5: makeNodeComponent("icon5"),
    content3: makeNodeComponent("content3"),
    text3: makeNodeComponent("text3"),
    nursingCard2: makeNodeComponent("nursingCard2"),
    cardHeader6: makeNodeComponent("cardHeader6"),
    title6: makeNodeComponent("title6"),
    icon6: makeNodeComponent("icon6"),
    content6: makeNodeComponent("content6"),
    text6: makeNodeComponent("text6"),

    // Metadata about props expected for PlasmicHomeSolutionsSection
    internalVariantProps: PlasmicHomeSolutionsSection__VariantProps,
    internalArgProps: PlasmicHomeSolutionsSection__ArgProps
  }
);

export default PlasmicHomeSolutionsSection;
/* prettier-ignore-end */
